import {useBreakpoints as useBreakpointsBase} from '@vueuse/core';

/**
 * Composable to add our often used breakpoints.
 */
export default function useBreakpoints() {
  const breakpoints = useBreakpointsBase({
    xs: '480px',
    sm: '576px',
    md: '720px',
    lg: '960px',
    xl: '1300px',
    '2xl': '1570px',
  });

  return breakpoints;
}
